// Turns a render-phase crash inside the mounted chart into the same chartReady
// error event the driver already handles, instead of an unmounted tree and silence.
// Spec: .aidev/tasks/headless-charts-sdk-spike/plans/20260727134139-render-route-hardening-plan.md §2 Крок 2

import { Component } from 'react'
import type { ErrorInfo, ReactNode } from 'react'

import { emitChartReady } from '@aytm/app/stats/page/question-views/components/charts/lib/exportable'

type Props = { requestId: string; children: ReactNode }
type State = { crashed: boolean }

export class ExportErrorBoundary extends Component<Props, State> {
  state: State = { crashed: false }

  static getDerivedStateFromError(): State {
    return { crashed: true }
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    const component = info.componentStack?.trim().split('\n')[0]?.trim()
    emitChartReady({
      requestId: this.props.requestId,
      error: `render crash: ${error.message}${component ? ` (at ${component})` : ''}`
    })
  }

  render(): ReactNode {
    return this.state.crashed ? null : this.props.children
  }
}

export default ExportErrorBoundary
